import Svg, { SvgProps } from './Svg';

export default function SparkSavingsIcon({ ...props }: SvgProps) {
  const id1 = 'linearGradient-spark' + Math.random().toString(16).slice(2);
  return (
    <Svg viewBox="0 0 96 96" fill="none" {...props}>
      <path
        d="M59.8357 53.3676H93.8564C95.165 53.3676 95.4286 51.5859 94.2387 51.0417L59.8378 35.3737V1.22002C59.8378 -0.0548029 58.1327 -0.473113 57.5444 0.657825L43.4018 27.8884L27.7303 20.6906C26.2309 20.0851 25.3101 21.3059 25.819 22.3551L35.1643 41.6324H1.14359C-0.164908 41.6324 -0.428616 43.414 0.761359 43.9582L35.1622 59.6265V93.7801C35.1622 95.0548 36.8673 95.4731 37.4556 94.3422L51.5982 67.1116L67.2698 74.3094C68.7691 74.9149 69.6899 73.6943 69.181 72.6449L59.8357 53.3676Z"
        fill={`url(#${id1})`}
      />
      <defs>
        <linearGradient
          id={id1}
          x1="76.5688"
          y1="25.2039"
          x2="15.3127"
          y2="72.1881"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FA43BD" />
          <stop offset="1" stopColor="#FFA930" />
        </linearGradient>
      </defs>
    </Svg>
  );
}
